import country from '../model/country';

const DELIVERY_FREE = 'Envío gratis';
const DELIVERY_FREE_BO = 'Envío sin costo';

export const DELIVERYS = {
  REIMBURSEMENT: 'REIMBURSEMENT',
  CASHBACK: 'CASHBACK',
  DISCOUNT: 'DISCOUNT',
  DELIVERY_DISCOUNT: 'DELIVERY_DISCOUNT',
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED',
};

export const getDeliveryFree = (countryId) => {
  switch (countryId) {
    case country.Bolivia:
      return DELIVERY_FREE_BO;
    default:
      return DELIVERY_FREE;
  }
};

export const renderDeliveryFee = (deliveryFee) => {
  if (deliveryFee === DELIVERY_FREE || deliveryFee === DELIVERY_FREE_BO) {
    return 0;
  }
  return parseFloat(deliveryFee?.replace('Envío $', ''));
};
